import React, {
  useEffect,
  useState
} from 'react'

import axios from 'axios'

import {
  useNavigate,
  useParams
} from 'react-router-dom'

import { useSelector } from 'react-redux'

import Navbar from '../Navbar'

import {
  FiAlertCircle,
  FiCheckCircle,
  FiMail
} from 'react-icons/fi'


export default function ChangeEmail() {

  const { token } =
    useParams()

  const navigate =
    useNavigate()

  const { url } =
    useSelector(state => state)

  const [loading, setLoading] =
    useState(true)

  const [message, setMessage] =
    useState('')

  const [error, setError] =
    useState('')


  useEffect(() => {

    if (!token) {

      navigate(
        '/dashboard/profile/'
      )

      return
    }


    const confirmEmailChange =
      async () => {

        try {

          const response =
            await axios.post(
              `${url}/auth/change-email/${token}`
            )


          const data =
            response.data


          if (data.message) {

            setMessage(
              data.message
            )


            setTimeout(() => {

              navigate(
                '/dashboard/profile/'
              )

            }, 2500)

            return
          }


          setError(
            data.error ||
            'Unable to change your email address.'
          )


        } catch (err) {

          console.error(
            'Change email error:',
            err
          )

          setError(
            err.response?.data?.detail ||
            err.response?.data?.error ||
            'This email change link may be invalid or expired.'
          )

        } finally {

          setLoading(false)
        }
      }


    confirmEmailChange()

  }, [
    token,
    url,
    navigate
  ])


  return (

    <div className="
      min-h-screen
      bg-[#F7F9FC]
      font-[Satoshi]
    ">

      <Navbar />


      <main className="
        lg:ml-[15em]
        min-h-screen
        flex
        items-start
        justify-center
        px-5
        py-12
        lg:py-20
      ">

        <div className="
          w-full
          max-w-xl
          bg-white
          border
          border-gray-200
          rounded-3xl
          shadow-sm
          px-6
          py-10
          lg:px-10
          text-center
        ">


          {loading && (

            <>

              <div className="
                w-14
                h-14
                rounded-2xl
                bg-green-50
                flex
                items-center
                justify-center
                mx-auto
                mb-5
              ">

                <div className="
                  w-6
                  h-6
                  rounded-full
                  border-2
                  border-green-200
                  border-t-green-600
                  animate-spin
                " />

              </div>


              <h1 className="
                text-2xl
                font-bold
              ">
                Confirming your email
              </h1>

              <p className="
                text-sm
                text-gray-500
                mt-2
              ">
                Please wait while we securely update your RentHub account.
              </p>

            </>

          )}


          {!loading && message && (

            <>

              <div className="
                w-16
                h-16
                rounded-2xl
                bg-green-50
                text-green-600
                flex
                items-center
                justify-center
                mx-auto
                text-3xl
                mb-6
              ">
                <FiCheckCircle />
              </div>


              <h1 className="
                text-2xl
                font-bold
              ">
                Email updated
              </h1>


              <p className="
                text-sm
                text-gray-500
                leading-6
                mt-3
              ">
                {message}
              </p>


              <p className="
                text-xs
                text-gray-400
                mt-5
              ">
                Returning you to your profile...
              </p>

            </>

          )}


          {!loading && error && (

            <>

              <div className="
                w-16
                h-16
                rounded-2xl
                bg-red-50
                text-red-600
                flex
                items-center
                justify-center
                mx-auto
                text-3xl
                mb-6
              ">
                <FiAlertCircle />
              </div>


              <h1 className="
                text-2xl
                font-bold
              ">
                We couldn't update your email
              </h1>


              <p className="
                text-sm
                text-gray-500
                leading-6
                mt-3
              ">
                {error}
              </p>


              <button
                type="button"
                onClick={() =>
                  navigate(
                    '/dashboard/profile/'
                  )
                }
                className="
                  w-full
                  h-12
                  bg-[#101828]
                  hover:bg-gray-800
                  text-white
                  rounded-xl
                  font-semibold
                  text-sm
                  mt-7
                  transition
                "
              >
                Return to profile
              </button>

            </>

          )}


          {!loading && !error && !message && (

            <FiMail className="
              text-green-600
              text-3xl
              mx-auto
            " />

          )}

        </div>

      </main>

    </div>
  )
}